// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resizeComponent {
	position: absolute !important;
	z-index: 999;
	border: solid 1px #333;
	/* background-color: #f0f0f0; */
	padding-left: 2px;
	border-radius: 4px;
	display: flex;
	user-select: auto;
	box-sizing: border-box;
	cursor: move;
}
.draggableComponent {
	position: absolute;
	z-index: 999;
	border: solid 1px #333;
}

.react-pdf__Page__canvas {
	border-radius: 8px;
	border: 1px solid #eee;
}

.ph-style {
	background: #fafafa;
	border-radius: 6px;
	padding: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/template-editor/pdf-block-dnd/pdf-placeholder/pdf-placeholder.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,YAAY;CACZ,sBAAsB;CACtB,+BAA+B;CAC/B,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,sBAAsB;CACtB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;AACb","sourcesContent":[".resizeComponent {\n\tposition: absolute !important;\n\tz-index: 999;\n\tborder: solid 1px #333;\n\t/* background-color: #f0f0f0; */\n\tpadding-left: 2px;\n\tborder-radius: 4px;\n\tdisplay: flex;\n\tuser-select: auto;\n\tbox-sizing: border-box;\n\tcursor: move;\n}\n.draggableComponent {\n\tposition: absolute;\n\tz-index: 999;\n\tborder: solid 1px #333;\n}\n\n.react-pdf__Page__canvas {\n\tborder-radius: 8px;\n\tborder: 1px solid #eee;\n}\n\n.ph-style {\n\tbackground: #fafafa;\n\tborder-radius: 6px;\n\tpadding: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
